import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef, useRef, useState, useEffect } from 'react';
import { PaginationButtonsEnum } from './interfaces.js';
import { PaginationItem } from './PaginationItem.js';
import { strings } from './strings.js';
import { Wrapper, PaginationList, DropdownWrapper } from './styles.js';
import { usePagination } from './usePagination.js';
import { defaultInfoFormatterPage } from './utils.js';
import DropdownNamespace from '../Dropdown/Dropdown.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const CHOOSE_DROPDOWN_WIDTH = '160px';
const CHOOSE_DROPDOWN_HEIGHT = '248px';
const Pagination = forwardRef((_a, ref) => {
    var { currentPage = 1, pageCount, onPageChange, showChoosePage, disableLastPage = false, nextAriaLabel = strings.ariaLabels.nextPage, pageAriaLabel = strings.ariaLabels.page, previousAriaLabel = strings.ariaLabels.prevPage, choosePageText = strings.choosePageText, appendPageDropdownTo, infoFormatter = defaultInfoFormatterPage, infiniteScroll } = _a, props = __rest(_a, ["currentPage", "pageCount", "onPageChange", "showChoosePage", "disableLastPage", "nextAriaLabel", "pageAriaLabel", "previousAriaLabel", "choosePageText", "appendPageDropdownTo", "infoFormatter", "infiniteScroll"]);
    const choosePageRef = useRef(null);
    const dropdownRef = useRef(null);
    const [isOpenChoosePage, setIsOpenChoosePage] = useState(false);
    const { itemList, uiItemList } = usePagination({
        numberOfPages: pageCount,
        activePage: currentPage,
    });
    useEffect(() => {
        const dropdownElement = dropdownRef.current;
        if (dropdownElement && currentPage) {
            const selectedPageItem = dropdownElement.children[currentPage - 1];
            dropdownElement.scrollTop = selectedPageItem.offsetTop - 8;
        }
    }, [isOpenChoosePage]);
    const handleIsOpenChoosePageDropdown = () => {
        setIsOpenChoosePage(!isOpenChoosePage);
    };
    const handleOnCloseChoosePageDropdown = () => {
        setIsOpenChoosePage(false);
    };
    const handleChoosePageViaDropdown = (page) => () => {
        setIsOpenChoosePage(false);
        if (onPageChange) {
            onPageChange(page);
        }
    };
    const uniqueEllipsisKey = '...2';
    const shouldShowChoosePage = showChoosePage && !disableLastPage && pageCount;
    return (React.createElement(Wrapper, Object.assign({ "aria-label": "pagina\u00E7\u00E3o" }, props, { ref: ref }),
        React.createElement(ParagraphMd, null, infoFormatter(currentPage, pageCount)),
        React.createElement(PaginationList, null, uiItemList.map((item, index) => {
            const isSecondEllipsis = item === PaginationButtonsEnum.ELLIPSIS && index > 2;
            return (React.createElement(PaginationItem, { key: isSecondEllipsis ? uniqueEllipsisKey : item, item: item, "aria-current": currentPage === item ? 'page' : undefined, currentPage: currentPage, pageCount: pageCount, onPageChange: onPageChange, previousAriaLabel: previousAriaLabel, nextAriaLabel: nextAriaLabel, pageAriaLabel: pageAriaLabel, disableLastPage: disableLastPage, infiniteScroll: infiniteScroll }));
        })),
        shouldShowChoosePage && (React.createElement(DropdownWrapper, null,
            React.createElement(DropdownNamespace.Toggle, { ref: choosePageRef, onClick: handleIsOpenChoosePageDropdown }, choosePageText),
            React.createElement(DropdownNamespace, { anchorElement: choosePageRef, isOpen: isOpenChoosePage, onClose: handleOnCloseChoosePageDropdown, maxHeight: CHOOSE_DROPDOWN_HEIGHT, maxWidth: CHOOSE_DROPDOWN_WIDTH, appendTo: appendPageDropdownTo, ref: dropdownRef }, itemList.map((item) => (React.createElement(DropdownNamespace.Item, { as: "button", onClick: handleChoosePageViaDropdown(item), key: item, "aria-label": `${pageAriaLabel} ${item}` }, item))))))));
});
Pagination.displayName = 'Pagination';

export { Pagination };
